import { Trash2 } from 'lucide-react'

// import {
//   Select,
//   SelectContent,
//   SelectGroup,
//   SelectItem,
//   SelectTrigger,
//   SelectValue,
// } from '~/design-system/atom/select'
// import { getCookie } from '~/utils/cookie'

type Role = 'admin' | 'developer'

interface MemberRowProps {
  name: string
  createdAt: string
  updatedAt: string
  role: string
  onDelete: () => void
  modifyTeamMemberRole: ({ id, role }: { id: string; role: Role }) => void
  email: string
  id: string
}

export function MemberRow({
  createdAt,
  updatedAt,
  // role = 'admin',
  onDelete,
  // modifyTeamMemberRole,
  email,
  // id,
}: MemberRowProps) {
  return (
    <div className="grid grid-cols-[1fr_1fr_1.5fr] items-center gap-4 p-4 hover:bg-gray-50">
      <div className="text-sm font-[400] text-gray-900">{email}</div>
      {/* <div className="text-sm font-[400] text-gray-900">
        <Select
          onValueChange={(e) => {
            // Handle role change logic here
            modifyTeamMemberRole({
              id,
              role: e === 'admin' ? 'admin' : 'developer',
            })
          }}
          disabled={email === getCookie('composio_email')}
          value={role}
        >
          <SelectTrigger className="h-8 min-w-28">
            <SelectValue placeholder="Select role" />
          </SelectTrigger>
          <SelectContent className="z-[300]">
            <SelectGroup>
              <SelectItem value="admin">Admin</SelectItem>
            </SelectGroup>
          </SelectContent>
        </Select>
      </div> */}
      <div className="text-sm text-gray-600">
        {createdAt ? new Date(createdAt).toLocaleDateString() : '--'}
      </div>

      <div className="flex items-center justify-between gap-[24px] text-sm text-gray-600">
        <div className="text-sm text-gray-600">
          {updatedAt ? new Date(updatedAt).toLocaleDateString() : '--'}
        </div>
        <button
          onClick={onDelete}
          className="text-red-400 hover:text-red-600"
          title="Delete team member"
        >
          <Trash2 size={16} />
        </button>
      </div>
    </div>
  )
}
